module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lPQFo"))).then(() => parcelRequire('9Lwss'));